const Color = require("color")
export const StandardDeviationPlugin = {
  id:"stddev",
  // beforeDatasetDraw:()=>{
  //   console.log("before")
  // },
  beforeDatasetDraw: drawSD,
  // afterEvent:drawSD
};
export function drawSD(chart,args,options) {
  var datasets = chart.data.datasets;
  var ctx = chart.ctx;
  var xAxis = chart.scales['x'];
  var yAxis = chart.scales['y'];
  for (var i = 0; i < datasets.length; i++) {
    var dataset = datasets[i];
    if (!dataset.showStdDev == true || dataset.hidden == true) {
      continue;
    }
    var data = dataset.data;
    var color = dataset.stdDevColor || dataset.borderColor || 'black';
    var stdDevs = calculateStdDevs(data);
    
    for (var j = 0; j < data.length; j++) {
      var x = xAxis.getPixelForValue(j);
      var y = yAxis.getPixelForValue(data[j]);
      var stdDev = stdDevs[j];
      var top = yAxis.getPixelForValue(data[j] + stdDev);
      var bottom = yAxis.getPixelForValue(data[j] - stdDev);
      var left = x - dataset.stdDevWidth/2 || 1;
      var right = x + dataset.stdDevWidth/2 || 1;
      
      ctx.save();
      ctx.strokeStyle = Color(color).fade(0.3).string();
      ctx.lineWidth = dataset.stdDevWidth || 1;
      ctx.beginPath();
      ctx.moveTo(x, top);
      ctx.lineTo(x, bottom);
      ctx.moveTo(left, bottom);
      ctx.lineTo(right, bottom);
      ctx.moveTo(left, top);
      ctx.lineTo(right, top);
      ctx.stroke();
      ctx.restore();
    }
  }
  // args.changed = true; //forces re render of chart
}
export function calculateStdDevs(data) {
  var mean = calculateMean(data);
  var variance = 0;
  for (var i = 0; i < data.length; i++) {
    variance += Math.pow(data[i] - mean, 2);
  }
  variance /= data.length;
  var stdDev = Math.sqrt(variance);
  var stdDevs = [];
  for (var i = 0; i < data.length; i++) {
    stdDevs.push(stdDev);
  }
  return stdDevs;
}

export function calculateMean(data) {
  var sum = 0;
  for (var i = 0; i < data.length; i++) {
    sum += data[i];
  }
  return sum / data.length;
}